import { render } from "./z-color-select.vue?vue&type=template&id=6a648cce&scoped=true&lang=pug"
import script from "./z-color-select.vue?vue&type=script&setup=true&lang=js"
export * from "./z-color-select.vue?vue&type=script&setup=true&lang=js"

import "./z-color-select.vue?vue&type=style&index=0&id=6a648cce&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a648cce"]])

export default __exports__